export default __webpack_public_path__ + "static/10_Rooster-ef4391b357af5c7811fb7beb6bf510f5.png";